module.exports = __webpack_public_path__ + "img/back-arrow.df881030.svg";